import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'

function AttendanceModal(props) {
    const [meetingLabel, setMeetingLabel] = useState("");
    const [date, setDate] = useState();
    const [attendance, setAttendance] = useState([]);
    const [buttonOrder, setButtonOrder] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [user, setUser] = useState({});

    const handleMeetingName = (e) => {
        setMeetingLabel(e.target.value);
    }
    const handleDateChange = (e) => {
        setDate(e.target.value);
    }
    const handleSave = async () => {
        if (attendance.length < props.teamData.members.length) {
            setErrorMessage("Select a status for all team members");
            return;
        }
        let attendanceRecord = {};
        attendance.forEach((record) => attendanceRecord[record.user_id] = record.attendance);
        const attendanceData = {
            group_id: props.teamData.members[0].group_id,
            meeting_subject: meetingLabel, 
            date: date,
            attendance_status: attendanceRecord, 
        }
        await axios.post(`${process.env.REACT_APP_API_HOST}/api/groups/attendance`, attendanceData, 
        {
            headers: {
                Authorization: `Bearer ${user.access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },

        })
        setAttendance([]);
        setButtonOrder([]);
        setErrorMessage("");
        props.handleAttendanceClose(attendanceRecord);
    }

    const handleAttendance = (student, type, position) => {  

        var unclick;

        if (buttonOrder.indexOf(position) > -1) {
            //if exist, remove
            setButtonOrder( prev => prev.filter( item => item !== position ))
            unclick = true;

        } else if(buttonOrder.indexOf(position + 100) > -1){
            //add to the selected array
            setButtonOrder( prev => prev.filter( item => item !== position + 100 ))
            setButtonOrder( prev => [ ...prev, position ] )

        } else if(buttonOrder.indexOf(position - 100) > -1){
            //add to the selected array
            setButtonOrder( prev => prev.filter( item => item !== position - 100 ))
            setButtonOrder( prev => [ ...prev, position ] )

        } else {
            //add to the selected array
            setButtonOrder( prev => [ ...prev, position ] )
        }   
  
        var operation;
        type === "absent" ? operation = false : operation = true;

        let item = new Object();
        item.user_id = student.user_id;
        item.attendance = operation;
        var index;


        attendance.map((data, i) => {

            if(data.user_id == student.user_id){
                index = i;
            }
        })
        if(index != undefined){
            attendance.splice(index, 1);
        }
        if(!unclick){
            attendance.push(item);
        }
  
  
    }
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "60%",
        minWidth: 300,
        maxWidth: 750,
        backgroundColor: 'white',
        boxShadow: 24,
        overflowY: 'auto',
        borderRadius: 10,
        paddingInline: 20, 
        padding: '20px',
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        setUser(user)
        const date = new Date();
        const year = date.getFullYear();
        var day;
        var month;

        date.getMonth() + 1 > 9 ? month = date.getMonth() + 1 : month = '0' + (date.getMonth() + 1);
        date.getDate() + 1 > 9 ? day = date.getDate() + 1 : day = '0' + (date.getDate());

        setDate(year + '-' + month + '-' + day);
    }, [])
    

  return (
    <div>
        <Modal
            open={props.open}
            onClose={() => props.handleAttendanceClose()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box style={modalStyle}>
            <Typography variant='h4' sx={{ fontWeight: 'bold'}}> Attendance</Typography>

                <Grid container spacing={2} justifyContent='center'>
                    <Grid item xs={12}>
                    </Grid>

                    <Grid item xs={7} style={{display: "flex", gap: "10px", alignItems: "center"}}>
                        <Typography variant='h6'>Meeting Subject: </Typography>
                        <TextField id='meetingSubject' size='small' placeholder='e.g. Sponsor Meeting' onChange={handleMeetingName}/>
                    </Grid>
                    <Grid item xs={5}  style={{display: "flex", gap: "10px", alignItems: "center"}}>
                        <Typography variant='h6'>Date: </Typography>
                        <TextField 
                            required
                            id='meetingDate'
                            size='small' 
                            type='date' 
                            defaultValue={date} 
                            onChange={handleDateChange}
                        />
                    </Grid>
                    <Grid container item xs={12} spacing={1} style={{margin: "0 auto"}}>
                        <Grid item xs={6}>
                            <Typography variant='h5' sx={{ fontWeight: 'bold'}}>Member</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant='h5' sx={{ fontWeight: 'bold'}}>Status</Typography>
                        </Grid>
                        {props.teamData.members ? props.teamData.members.map((data, i) => (
                            <React.Fragment key={i}>
                                <Grid item xs={6}>
                                    <Typography>{data.first_name + ' ' + data.last_name}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Button size='small' variant={buttonOrder.indexOf(i) > -1? 'contained' : 'outlined'} onClick={() => handleAttendance(data, 'absent', i)}>Absent</Button>
                                </Grid>
                                <Grid item xs={2}>
                                    <Button size='small' variant={buttonOrder.indexOf(i + 100) > -1? 'contained' : 'outlined'} onClick={() => handleAttendance(data, 'present', i + 100)}>Present</Button>
                                </Grid>
                            </React.Fragment>
                        )) : null}
                    </Grid>

                    <Grid container spacing={1} justifyContent='center' sx={{paddingTop: '30px'}}>
                        <Grid item xs={6}>
                            <Typography color="red">{errorMessage}</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Button variant='contained' onClick={handleSave}>Submit</Button>
                        </Grid>
                    </Grid>

                </Grid>

            </Box>
        </Modal>
    </div>
)
}

export default AttendanceModal
